import { Location } from '@angular/common';
import { Component, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'underscore';
import { environment } from '../environment';
import { Auth } from '../shared/services/auth';
import { Configuration } from '../shared/services/configuration';
import { HttpClientCustom } from '../shared/services/http.client';
import { SharedData } from '../shared/sharedData';
import { ToasterComponent } from '../toasterComponent/toasterComponent';

@Component({
  selector: 'ToolsMenu',
  templateUrl: 'tenantPreference.html'
})
export class TenantPreferenceComponent {
  public _baseUrl: any;
  public displayPreferences: any = 2;
  public weekStartDay: any;
  public tenantFont: any = null;
  public monthStartDay: any;
  public paginationValue: any;
  public paginationValueGrid: any;
  public emailDomain: any;
  public num: any = 123;
  public numberOfMonthsDateTargetCanExceed: number = 0;
  public logoutVal: any;
  public applicableUOMValue: any;
  public shareWith: any;
  public scd: any;
  public arr: any = [];
  public payloadArray: any = [];
  public share: any;
  public comment: any;
  public discuss: any;
  public like: any;
  public dateFormat: any;
  public userCanShareWith: any;
  public isCommentDisableForAdminPost: any;
  public enableAverageOption: any;
  public enableAnalytics: any;
  public analyticsToken: any;
  public allowMultipleStrategy: any;
  public canCoachMultipleUsers: any;
  public tenantImageDataHolder = {
    attachment: { docName: null, docType: null, document: null, docId: null },
    biAttachment: { docName: null, docType: null, document: null, docId: null },
    isTenantImage: true,
  };
  public tenantLoginLogoDataHolder = {
    attachment: { docName: null, docType: null, document: null, docId: null },
    biAttachment: { docName: null, docType: null, document: null, docId: null },
    isTenantImage: true,
  };
  public tenantLoaderDataHolder = {
    attachment: { docName: null, docType: null, document: null, docId: null },
    biAttachment: { docName: null, docType: null, document: null, docId: null },
    isTenantImage: true,
  };
  public allow = false;
  public allowBI: boolean;
  public primaryColor: any;
  public isToDoEnabled: any;
  public pushKpiEnabled: any;
  public client: any = 'KEA';
  public isScorecardHistoryEnabled: any = true;
  public isOverallScoreAsDescription: any;
  public isDisplayTenantLogoInUserPicture: Boolean = false;
  public headerColor: any;
  public isRoundOffOverallScore: any;
  public changedConfigData: any = [];
  public isToDoTaskAssigned: any;
  public canSuperviosrViewAnnualScore: boolean;
  public canEmployeeViewAnnualScore: boolean;
  public canSwitchViewAnnualScore: boolean;
  public canReportViewAnnualScore:boolean;
  public changeRelationship:boolean = true;
  public resetToCreated:boolean = true;
  public reflectChanges:boolean = true;
  public changeAndReset:boolean = true;
  constructor(
    public route: ActivatedRoute,
    public activeModal: NgbActiveModal,
    public _location: Location,
    public _toast: ToasterComponent,
    public viewContainerRef: ViewContainerRef,
    public _http: HttpClientCustom,
    public _global: Configuration,
    public translate: TranslateService,
    public _share: SharedData,
    public _auth: Auth,
  ) {
    this._baseUrl = _global.get('EPMS_BASE_URL');
    _toast.setViewRef(viewContainerRef);
    this.getAll();
    this.onInputChange();
    this.client = environment.client;
    this.getTenantFont();
  }

  public getAll(): any {
    try {
      let url = this._baseUrl + 'v1/webAdmin/tenantConfig/getConfigData';
      this._http.get(url).subscribe(result => {
        this.formatData(result);
      });
    } catch (e) {
      console.log('download error caught', e);
    }
  }

  public saveTenantConfigData(changedConfigData): any {
    try {
      let url =
        this._baseUrl + 'v1/webAdmin/tenantConfig/saveTenantConfigurations';
      this._http.post(url, changedConfigData).subscribe(result => {
        if (result.data == null && result.success) {
          this.translate.get('tenantConfigSaved').subscribe(msg => {
            this._toast.showSuccess(msg);
            this.payloadArray = [];
            this.arr = [];
            this.getAll();
            this.onInputChange();
            this.client = environment.client;
            this.getTenantFont();
          });
        } else {
          this.translate.get('errorUpdateTenantConfig').subscribe(msg => {
            this._toast.showError(msg);
          });
        }
      });
    } catch (e) {
      console.log('download error caught', e);
    }
  }

  public onInputChange() {
    let n = 123;
    this.num = n.toFixed(this.displayPreferences);
  }

  public formatData(data) {
    let self = this;
    _.each(data, function (key, val) {
      self.getDefaultValues(key.key, key.value, key.id);
    });
  }

  public getDefaultValues(key, value, id) {
    let self = this;
    if (key == 'UPLOAD_PHOTO') {
      this.allow = value;
    }

    if (key == 'ANNOUNCEMENT_PERMISSION') {
      this.userCanShareWith = value;
    }

    if (key == 'WEIGHTAGE_VIEW_DF') {
      self.displayPreferences = value;
    }
    if (key == 'PAGINATION_VALUE') {
      self.paginationValue = value;
    }
    if (key == 'SCD_COLLABORATION') {
      self.scd = value;
      let val = value.split(',');
      if (val.length > 0) {
        _.each(val, function (k, v) {
          if (k == 'SHARE') {
            self.share = true;
          }
          if (k == 'COMMENT') {
            self.comment = true;
          }
          if (k == 'DISCUSSION') {
            self.discuss = true;
          }
          if (k == 'LIKE') {
            self.like = true;
          }
        });
      }
    }

    if (key == 'SHARE_CONFIGURATION') {
      self.shareWith = value;
    }

    if (key == 'AGGREGATE_APPLICABLE_UOMS') {
      self.applicableUOMValue = value;
    }

    if (key == 'ENABLE_AVERAGE_OPTION_FOR_YTD_PROGRAM') {
      self.enableAverageOption = (value == 'true');
    }

    if (key == 'ENABLE_ANALYTICS') {
      self.enableAnalytics = (value == 'true');
    }

    if (key == 'ANALYTICS_TOKEN') {
      self.analyticsToken = value;
    }

    if (key == 'MONTH_START') {
      self.monthStartDay = value;
    }

    if (key == 'WK_START') {
      self.weekStartDay = value;
    }

    if (key == 'PAGINATION_VALUE_PER_GRID') {
      self.paginationValueGrid = value;
    }

    if (key == 'EMAIL_DOMAIN_ALLOWED') {
      self.emailDomain = value;
    }

    if (key == 'MAX_EXTRA_MONTHS_CAN_SHOW_FOR_DATE_BASED_KPI') {
      self.numberOfMonthsDateTargetCanExceed = value;
    }

    if (key == 'MOBILE_SESSION_TIMEOUT') {
      self.logoutVal = value;
    }

    if (key == 'DATE_FORMAT') {
      self.dateFormat = value;
    }
    if (key == 'PRIMARY_COLOR') {
      self.primaryColor = value;
    }
    if (key == 'THINGS_TO_DO') {
      self.isToDoEnabled = value;
    }

    if (key == 'PUSH_KPI_OPTION_ENABLED') {
      self.pushKpiEnabled = value;
    }

    if (key == 'SCORECARD_HISTORY') {
      self.isScorecardHistoryEnabled = value;
    }
    if (key == 'SHOW_DISPLAY_PICTURE_AS_TENANT_LOGO') {
      if (value == 'true') {
        self.isDisplayTenantLogoInUserPicture = true;
      } else {
        self.isDisplayTenantLogoInUserPicture = false;
      }
    }
    if (key == 'COMMENT_ON_ADMIN_POST') {
      this.isCommentDisableForAdminPost = value.toLowerCase() == 'true' ? true : false;
    }
    if (key == 'CAN_SELECT_MULTIPLE_USERS_TO_COACH') {
      this.canCoachMultipleUsers = value;
    }
    if (key == 'SHOW_OVERALL_SCORE_AS_DESCRIPTION') {
      if (value == 'true') {
        self.isOverallScoreAsDescription = true;
      } else {
        self.isOverallScoreAsDescription = false;
      }
    }
    if (key == 'TO_DO_CARD_FOR_TASK_ASSIGNED') {
      if (value == 'true') {
        self.isToDoTaskAssigned = true;
      } else {
        self.isToDoTaskAssigned = false;
      }
    }

    if (key == 'HEADER_COLOR') {
      self.headerColor = value;
    }
    if (key == 'ALLOW_MULTIPLE_STRATEGY') {
      self.allowMultipleStrategy = value.toLowerCase() == 'true' ? true : false;
    }
    if (key == 'ROUNDOFF_OVERALL_SCORE') {
      self.isRoundOffOverallScore = value.toLowerCase() == 'true' ? true : false;
    }
    if (key == 'SUPERVISOR_CAN_VIEW_ANNUAL_SCORE') {
      self.canSuperviosrViewAnnualScore = value.toLowerCase() == 'true' ? true : false;
    }
    if (key == 'SWITCH_USER_CAN_VIEW_ANNUAL_SCORE') {
      self.canSwitchViewAnnualScore = value.toLowerCase() == 'true' ? true : false;
    }
    if (key == 'EMPLOYEE_CAN_VIEW_ANNUAL_SCORE') {
      self.canEmployeeViewAnnualScore = value.toLowerCase() == 'true' ? true : false;
    }
    if (key == 'IN_REPORT_CAN_VIEW_ANNUAL_SCORE') {
      self.canReportViewAnnualScore = value.toLowerCase() == 'true' ? true : false;
    }
    if(key == 'CHANGE_SUBORD_KPI'){
        self.reflectChanges =  value.toLowerCase() == 'true' ? true : false;
    }
    if(key == 'CHANGE_RELATIONSHIP_AS_TRANSLATE'){
        self.changeRelationship =  value.toLowerCase() == 'true' ? true : false;
    }
    if(key == 'RESET_SUBORD_SC_TO_CREATED'){
        self.resetToCreated =  value.toLowerCase() == 'true' ? true : false;
    }
     if(key == 'CHANGE_SUBORD_KPI_TO_INDIVIDUAL_AND_RESET'){
         self.changeAndReset =  value.toLowerCase() == 'true' ? true : false;
        }
    self.arr.push({ id: id, configKey: key, value: value });
  }

  public allowPicture(event) {
    this.allow = event.target.checked;
  }

  public disableTodo(event) {
    this.isToDoEnabled = !event.target.checked;
  }

  public updatePushKpiOption(event) {
    this.pushKpiEnabled = event.target.checked;
  }

  public disableCoachMultipleUsers(event) {
    this.canCoachMultipleUsers = event.target.checked;
  }

  public disableScorecardHistory(event) {
    this.isScorecardHistoryEnabled = !event.target.checked;
  }

  public formatPayload() {
    let flag = false;
    let self = this;
    this.saveImage();
    this.saveLogoImage();
    this.saveLoaderImage();
    if (this.tenantFont != null && this.tenantFont != 'null') {
      this.saveTenantFont();
    }
    if (this.displayPreferences === '' || this.displayPreferences == null) {
      this.translate.get('displayPrefMandatory').subscribe(msg => {
        this._toast.showError(msg);
      });
      return false;
    }
    if (this.paginationValue === '' || this.paginationValue == null) {
      this.translate.get('recordMandatoryHub').subscribe(msg => {
        this._toast.showError(msg);
      });
      return false;
    }
    if (this.paginationValue < 1) {
      this.translate.get('recordCanNotBeZero').subscribe(msg => {
        this._toast.showError(msg);
      });
      return false;
    }
    if (this.paginationValue > 100) {
      this.translate.get('recordCanNotBeGrtHun').subscribe(msg => {
        this._toast.showError(msg);
      });
      return false;
    }
    if (this.paginationValueGrid === '' || this.paginationValueGrid == null) {
      this.translate.get('displayGridMand').subscribe(msg => {
        this._toast.showError(msg);
      });
      return false;
    }
    if (this.paginationValueGrid < 1) {
      this.translate.get('displayGridZero').subscribe(msg => {
        this._toast.showError(msg);
      });
      return false;
    }
    if (this.paginationValueGrid > 100) {
      this.translate.get('gridGreaterThanHund').subscribe(msg => {
        this._toast.showError(msg);
      });
      return false;
    }
     if (!(this.changeRelationship || this.reflectChanges || this.resetToCreated)) {
      this.translate.get('selectSubordinateScorecardOption').subscribe(msg => {
        this._toast.showError(msg);
      });
      return false;
    }
    for (let i = 0; i < self.arr.length; i++) {
      flag = self.getPayload(
        self.arr[i].id,
        self.arr[i].configKey,
        self.arr[i].value
      );
      if (!flag) {
        return;
      }
    }
    if (flag) {
      this.changedData(this.payloadArray)
    }
  }
  public changedData(configPayload) {
    let self = this;
    self.changedConfigData = [];
    _.each(self.arr, function (element, index) {
      if (configPayload[index].configKey == element.configKey) {
        if (configPayload[index].value != element.value) {
          self.changedConfigData.push(configPayload[index]);
        }
      }
    })
    self.saveTenantConfigData(self.changedConfigData);
  }

  public getPayload(id, key, value) {
    if (
      key == 'WEIGHTAGE_VIEW_DF' ||
      key == 'WEIGHTAGE_DF' ||
      key == 'TARGET_ACTUAL_DF' ||
      key == 'PERF_SCORE_DF'
    ) {
      value = this.displayPreferences;
    }
    if (key == 'PAGINATION_VALUE') {
      value = this.paginationValue;
    }
    if (key == 'SCD_COLLABORATION') {
      let val = [];
      if (this.share) {
        val.push('SHARE');
      }
      if (this.comment) {
        val.push('COMMENT');
      }
      if (this.discuss) {
        val.push('DISCUSSION');
      }
      if (this.like) {
        val.push('LIKE');
      }
      value = val.join();
    }

    if (key == 'SHARE_CONFIGURATION') {
      value = this.shareWith;
    }

    if (key == 'AGGREGATE_APPLICABLE_UOMS') {
      value = this.applicableUOMValue;
    }

    if (key == 'MONTH_START') {
      value = this.monthStartDay;
    }

    if (key == 'WK_START') {
      value = this.weekStartDay;
    }
    if (key == 'PAGINATION_VALUE_PER_GRID') {
      value = this.paginationValueGrid;
    }

    if (key == 'EMAIL_DOMAIN_ALLOWED') {
      value = this.emailDomain;
    }

    if (key == 'ENABLE_AVERAGE_OPTION_FOR_YTD_PROGRAM') {
      value = JSON.stringify(this.enableAverageOption);
    }

    if (key == 'MAX_EXTRA_MONTHS_CAN_SHOW_FOR_DATE_BASED_KPI') {
      value = this.numberOfMonthsDateTargetCanExceed;
    }

    if (key == 'ENABLE_ANALYTICS') {
      value = JSON.stringify(this.enableAnalytics);
    }

    if (key == 'ANALYTICS_TOKEN') {
      value = this.analyticsToken;
    }

    if (key == 'MOBILE_SESSION_TIMEOUT') {
      value = this.logoutVal;
    }

    if (key == 'DATE_FORMAT') {
      value = this.dateFormat;
    }

    if (key == 'UPLOAD_PHOTO') {
      value = this.allow;
    }

    if (key == 'ANNOUNCEMENT_PERMISSION') {
      value = this.userCanShareWith;
    }
    if (key == 'PRIMARY_COLOR') {
      value = this.primaryColor;
    }
    if (key == 'THINGS_TO_DO') {
      value = this.isToDoEnabled;
    }

    if (key == 'PUSH_KPI_OPTION_ENABLED') {
      value = this.pushKpiEnabled;
    }
    if (key == 'SCORECARD_HISTORY') {
      value = this.isScorecardHistoryEnabled;
    }
    if (key == 'SHOW_DISPLAY_PICTURE_AS_TENANT_LOGO') {
      value = JSON.stringify(this.isDisplayTenantLogoInUserPicture);
    }
    if (key == 'COMMENT_ON_ADMIN_POST') {
      value = JSON.stringify(this.isCommentDisableForAdminPost);
    }
    if (key == 'CAN_SELECT_MULTIPLE_USERS_TO_COACH') {
      value = this.canCoachMultipleUsers;
    }
    if (key == 'SHOW_OVERALL_SCORE_AS_DESCRIPTION') {
      value = JSON.stringify(this.isOverallScoreAsDescription);

    }
    if (key == 'HEADER_COLOR') {
      value = this.headerColor;
    }

    if (key == 'ALLOW_MULTIPLE_STRATEGY') {
      value = JSON.stringify(this.allowMultipleStrategy);
    }

    if (key == 'ROUNDOFF_OVERALL_SCORE') {
      value = JSON.stringify(this.isRoundOffOverallScore);
    }
    if (key == 'TO_DO_CARD_FOR_TASK_ASSIGNED') {
      value = this.isToDoTaskAssigned;

    }
    if (key == 'SUPERVISOR_CAN_VIEW_ANNUAL_SCORE') {
      value = this.canSuperviosrViewAnnualScore;
    }
    if (key == 'SWITCH_USER_CAN_VIEW_ANNUAL_SCORE') {
      value = this.canSwitchViewAnnualScore;
    }
    if (key == 'EMPLOYEE_CAN_VIEW_ANNUAL_SCORE') {
      value = this.canEmployeeViewAnnualScore;
    }
    if (key == 'IN_REPORT_CAN_VIEW_ANNUAL_SCORE') {
      value = this.canReportViewAnnualScore;
    }
     if (key == 'CHANGE_SUBORD_KPI') {
      value = this.reflectChanges;
    }
     if (key == 'CHANGE_RELATIONSHIP_AS_TRANSLATE') {
      value = this.changeRelationship;
    }
     if (key == 'RESET_SUBORD_SC_TO_CREATED') {
      value = this.resetToCreated;
    }
    if(key == 'CHANGE_SUBORD_KPI_TO_INDIVIDUAL_AND_RESET'){
        value = this.changeAndReset;
    }
    this.payloadArray.push({ id: id, configKey: key, value: value });
    return true;
  }

  goToBackPage() {
    this._location.back();
  }

  onSelectionChange($event) {
  }

  public fileChange(event) {
    console.log(event);

    const fileList: FileList = event.target.files;
    let result: any;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const fileName = file.name;
      const path = event.target.value;
      const reader = new FileReader();
      reader.onloadend = (e: any) => {
        result = e.target.result;
        this.getAllData(path, fileName, result);
      };
      reader.readAsBinaryString(file);
    }
  }

  public BIFileChange(event) {
    const fileList: FileList = event.target.files;
    let result: any;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const fileName = file.name;
      const path = event.target.value;
      const reader = new FileReader();
      reader.onloadend = (e: any) => {
        result = e.target.result;
        this.getAllBIData(path, fileName, result);
      };
      reader.readAsBinaryString(file);
    }
  }

  public getAllBIData(path, fileNames, result) {
    const a = path.split('/');
    const fileName = a.pop();
    const fileNameArray = fileName.split('.');
    const onlyName = fileNameArray[0];
    const ext = fileNameArray[1];

    this.tenantImageDataHolder.biAttachment = {
      docName: fileNames,
      docType: ext,
      document: window.btoa(result),
      docId: null
    };
  }



  public getAllData(path, fileNames, result) {
    const a = path.split('/');
    const fileName = a.pop();
    const fileNameArray = fileName.split('.');
    const onlyName = fileNameArray[0];
    const ext = fileNameArray[1];

    this.tenantImageDataHolder.attachment = {
      docName: fileNames,
      docType: ext,
      document: window.btoa(result),
      docId: null
    };
  }

  saveImage() {
    try {
      console.log(this.tenantImageDataHolder);
      let url = this._baseUrl + 'v1/webAdmin/tenantConfig/tenantImage';
      this._http.put(url, this.tenantImageDataHolder).subscribe(result => {
        this.getEmployeeDetail();
      });
    } catch (e) {
      console.log('Upload error', e);
    }
  }

  saveTenantFont() {
    try {
      let url = this._baseUrl + 'v1/webAdmin/tenantConfig/tenantFont/' + this.tenantFont;
      this._http.post(url, {}).subscribe(result => {
      });
    } catch (e) {
      console.log('tenant font error', e);
    }
  }

  getTenantFont() {
    try {
      let url = this._baseUrl + 'v1/webAdmin/tenantConfig/tenantFont';
      this._http.get(url).subscribe(result => {
        if (result.data != null) {
          this.tenantFont = result.data;
        }
      });
    } catch (e) {
      console.log('Upload error', e);
    }
  }

  public logoFileChange(event) {
    console.log(event);

    const fileList: FileList = event.target.files;
    let result: any;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const fileName = file.name;
      const path = event.target.value;
      const reader = new FileReader();
      reader.onloadend = (e: any) => {
        result = e.target.result;
        this.getAllLogonLogoData(path, fileName, result);
      };
      reader.readAsBinaryString(file);
    }
  }

  public loaderFileChange(event) {
    console.log(event);

    const fileList: FileList = event.target.files;
    let result: any;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const fileName = file.name;
      const path = event.target.value;
      const reader = new FileReader();
      reader.onloadend = (e: any) => {
        result = e.target.result;
        this.getAllLoaderData(path, fileName, result);
      };
      reader.readAsBinaryString(file);
    }
  }

  public getAllLogonLogoData(path, fileNames, result) {
    const a = path.split('/');
    const fileName = a.pop();
    const fileNameArray = fileName.split('.');
    const onlyName = fileNameArray[0];
    const ext = fileNameArray[1];

    this.tenantLoginLogoDataHolder.attachment = {
      docName: fileNames,
      docType: ext,
      document: window.btoa(result),
      docId: null
    };

  }

  public getAllLoaderData(path, fileNames, result) {
    const a = path.split('/');
    const fileName = a.pop();
    const fileNameArray = fileName.split('.');
    const onlyName = fileNameArray[0];
    const ext = fileNameArray[1];
    if (ext != 'gif') {
      this.translate.get('Please Select Gif File').subscribe((msg) => {
        this._toast.showError(msg);
      });
      return false;
    } else {
      this.tenantLoaderDataHolder.attachment = {
        docName: fileNames,
        docType: ext,
        document: window.btoa(result),
        docId: null
      };
    }
  }

  public saveLogoImage() {
    try {
      let url = this._baseUrl + 'v1/webAdmin/tenantConfig/tenantLogo';
      this._http.put(url, this.tenantLoginLogoDataHolder).subscribe(result => {
        this.getEmployeeDetail();
      });
    } catch (e) {
      console.log('Upload error', e);
    }
  }

  public saveLoaderImage() {
    try {
      console.log('logo data::' + this.tenantLoaderDataHolder);
      let url = this._baseUrl + 'v1/webAdmin/tenantConfig/tenantLoader';
      this._http.put(url, this.tenantLoaderDataHolder).subscribe(result => {
        this.getEmployeeDetail();
      });
    } catch (e) {
      console.log('Upload error', e);
    }
  }

  public allowSameLogo(event) {
    if (event.target.checked == true) {
      this.allowBI = false;
      this.tenantImageDataHolder.isTenantImage = true;
    }
    else {
      this.allowBI = true;
      this.tenantImageDataHolder.isTenantImage = false;
    }
  }

  public getEmployeeDetail() {
    let self = this;
    const url = self._baseUrl + 'v1/hub/employeeInfo';
    return self._http.get(url).subscribe(result => {
      this._auth.updateUser(result);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/tools/tenantPreference.ts